export default __webpack_public_path__ + "static/media/Notifications.93e4aae3.svg";